import InputGroup from "@/components/ui/input-group";
import { MdOutlineLocalOffer } from "react-icons/md";

type Props = {
  value: string;
  onChange: (value: string) => void;
};

const PromoCodeInput = ({ value, onChange }: Props) => {
  return (
    <InputGroup className="bg-[#F0F0F0]">
      <InputGroup.Text>
        <MdOutlineLocalOffer className="text-black/40 text-2xl" />
      </InputGroup.Text>
      <InputGroup.Input
        type="text"
        name="code"
        placeholder="Add promo code"
        value={value}
        onChange={(e) => onChange(e.target.value)}
        className="bg-transparent placeholder:text-black/40"
      />
    </InputGroup>
  );
};

export default PromoCodeInput;